
<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div class="auth-wrapper auth-v2">
      <b-row class="auth-inner m-0">
        <b-link class="brand-logo">
          <vuexy-logo />
        </b-link>

        <b-col
            lg="8"
            class="d-none d-lg-flex align-items-center p-5"
        >
          <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
            <b-img
                fluid
                :src="imgUrl"
                alt="Login V2"
            />
          </div>
        </b-col>

        <b-col
            lg="4"
            class="d-flex align-items-center auth-bg px-2 p-lg-5"
        >
          <b-col
              sm="8"
              md="6"
              lg="12"
              class="px-xl-2 mx-auto"
          >
            <b-card-title
                class="mb-1 font-weight-bold"
                title-tag="h2"
            >
              به پنل ادمین بنفشه باقری خوش آمدید 👋
            </b-card-title>

            <b-card-text class="mb-2">
              لطفا به حساب کاربری خود وارد شوید.
            </b-card-text>

            <validation-observer
                ref="loginForm"
                v-slot="{ invalid }"
            >
              <b-form
                  class="auth-login-form mt-2"
                  @submit.prevent="login"
              >
                <b-form-group
                    label="تلفن همراه"
                    label-for="login-mobile"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Mobile"
                      vid="mobile"
                      rules="required|integer"
                  >
                    <b-form-input
                        id="login-mobile"
                        v-model="mobile"
                        :state="errors.length > 0 ? false : null"
                        name="login-mobile"
                        placeholder="---------09"
                        :disabled="showOverlay"
                    />

                    <small class="text-danger">
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </b-form-group>

                <b-form-group>
                  <validation-provider
                      v-slot="{ errors }"
                      name="Password"
                      vid="password"
                      rules="required"
                  >
                    <b-input-group
                        class="input-group-merge"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                          id="login-password"
                          v-model="password"
                          :state="errors.length > 0 ? false : null"
                          class="form-control-merge"
                          :type="passwordFieldType"
                          name="login-password"
                          placeholder="*****"
                          :disabled="showOverlay"
                      />

                      <b-input-group-append is-text>
                        <feather-icon
                            class="cursor-pointer"
                            :icon="passwordToggleIcon"
                            @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>

                    <small class="text-danger">
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </b-form-group>

                <b-form-group>
                  <b-form-checkbox
                      id="remember-me"
                      v-model="status"
                      name="checkbox-1"
                      :disabled="showOverlay"
                  >
                    مرا به خاطر بسپار
                  </b-form-checkbox>
                </b-form-group>

                <b-button
                    type="submit"
                    variant="primary"
                    block
                    :disabled="invalid || showOverlay"
                >
                  ورود
                </b-button>
              </b-form>
            </validation-observer>
          </b-col>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver
} from 'vee-validate'

import VuexyLogo from '@core/layouts/components/Logo.vue'

import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BOverlay
} from 'bootstrap-vue'

import useJwt from '@/auth/jwt/useJwt'
import { required, integer } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { getAbilitiesForRole } from '@/auth/rolePermissions'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'Login',

  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    BOverlay,
    ValidationProvider,
    ValidationObserver
  },

  mixins: [togglePasswordVisibility],

  data() {
    return {
      status: false,
      password: '',
      mobile: '',
      showOverlay: false,
      required,
      integer
    }
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password'
          ? 'EyeIcon'
          : 'EyeOffIcon'
    },

    imgUrl() {
      return store.state.appConfig.layout.skin === 'dark'
          ? require('@/assets/images/pages/login-v2-dark.svg')
          : require('@/assets/images/pages/login-v2.svg')
    }
  },

  methods: {
    showToast(text, variant = 'danger', title = '') {
      this.$toast({
        component: ToastificationContent,
        position: 'bottom-left',
        props: {
          title,
          variant,
          icon: variant === 'success'
              ? 'CheckIcon'
              : 'AlertCircleIcon',
          text
        }
      })
    },

    getUserAbility(role) {
      return getAbilitiesForRole(role)
    },

    async login() {
      if (this.showOverlay) {
        return
      }

      this.showOverlay = true

      try {
        const isValid = await this.$refs.loginForm.validate()

        if (!isValid) {
          return
        }

        const response = await useJwt.login({
          mobileOrEMail: this.mobile.trim(),
          password: this.password
        })

        const responseData = response && response.data

        if (!responseData || !responseData.isSuccess) {
          this.showToast(
              responseData && responseData.errorMessage
                  ? responseData.errorMessage
                  : 'ورود ناموفق بود. لطفا اطلاعات خود را بررسی کنید.'
          )
          return
        }

        const userData = responseData.data &&
            responseData.data.data

        if (!userData || !userData.user) {
          this.showToast(
              'اطلاعات کاربر از سمت سرور به درستی دریافت نشد.'
          )
          return
        }

        const userRole = typeof userData.user.role === 'string'
            ? userData.user.role.trim()
            : ''

        if (!userRole || userRole === 'Subscriber') {
          this.showToast(
              'شما اجازه ورود به پنل ادمین را ندارید.'
          )
          return
        }

        const userAbility = this.getUserAbility(userRole)

        if (!userAbility.length) {
          this.showToast(
              'سطح دسترسی نقش کاربری شما در پنل تعریف نشده است.'
          )
          return
        }

        if (!userData.token) {
          this.showToast(
              'توکن ورود از سمت سرور دریافت نشد.'
          )
          return
        }

        const homeRoute = getHomeRouteForLoggedInUser(userRole)

        if (
            !homeRoute ||
            typeof homeRoute !== 'string' ||
            homeRoute === '/error-404'
        ) {
          this.showToast(
              'مسیر ورود به پنل برای نقش کاربری شما به درستی تعریف نشده است.'
          )
          return
        }

        userData.ability = userAbility

        useJwt.setToken(userData.token)

        if (userData.refreshToken) {
          useJwt.setRefreshToken(userData.refreshToken)
        } else {
          useJwt.setRefreshToken('')
        }

        localStorage.setItem(
            'userData',
            JSON.stringify(userData)
        )

        this.$ability.update(userAbility)

        this.showToast(
            `شما به عنوان ${userRole} وارد شدید.`,
            'success',
            `خوش آمدید ${userData.user.name || ''}`
        )

        window.location.href = homeRoute
      } catch (error) {
        const serverError = error &&
            error.response &&
            error.response.data

        const errorMessage = serverError
            ? serverError.errorMessage ||
            serverError.message ||
            'خطا در ورود به حساب کاربری.'
            : 'ارتباط با سرور برقرار نشد. لطفا دوباره تلاش کنید.'

        this.showToast(errorMessage)
      } finally {
        this.showOverlay = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
